import React from 'react';
import dayjs from '../_util/day';
import { useConfig } from '../hooks/useConfig';
import { getText } from './util';
import { jsx as _jsx } from "react/jsx-runtime";
export const IntervalTiming = props => {
  const {
    start,
    end,
    timeSpan,
    canShowMonth = true
  } = props;
  const {
    locale: {
      Day: DayLocale
    }
  } = useConfig();
  if (!timeSpan && (!start || !end)) return /*#__PURE__*/_jsx("span", {
    children: "-"
  });
  const difference = dayjs(end).diff(dayjs(start));
  var parseMs = function parseMs(milliseconds) {
    return {
      days: Math.floor(milliseconds / 86400000),
      hours: Math.floor(milliseconds / 3600000) % 24,
      minutes: Math.floor(milliseconds / 60000) % 60,
      seconds: Math.floor(milliseconds / 1000) % 60,
      milliseconds: Math.floor(milliseconds) % 1000
    };
  };
  const formattedRes = parseMs(timeSpan !== null && timeSpan !== void 0 ? timeSpan : difference);
  const text = getText(formattedRes, DayLocale, canShowMonth);
  return /*#__PURE__*/_jsx("span", {
    children: text
  });
};